"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageType = void 0;
var PageType;
(function (PageType) {
    /**
     * 商品详情页
     */
    PageType["ProductDetail"] = "productdetail";
})(PageType = exports.PageType || (exports.PageType = {}));
